
namespace Matrix.Exceptions {

    @Serenity.Decorators.registerClass()
    export class ExceptionInboxGrid extends SiteEntityGrid<ExceptionRow, any> {
        protected getColumnsKey() { return ExceptionInboxColumns.columnsKey; }
        protected getDialogType() { return ExceptionInboxDialog; }
        protected getIdProperty() { return ExceptionRow.idProperty; }
        protected getInsertPermission() { return ExceptionRow.insertPermission; }
        protected getLocalTextPrefix() { return ExceptionRow.localTextPrefix; }
        protected getService() { return ExceptionService.baseUrl; }

        private popupMenuEl: JQuery;

        constructor(container: JQuery) {
            super(container);

            this.element.on('click.' + this.uniqueName, '.exception-links', (e) => {

                if (!this.popupMenuEl) {
                    this.popupMenuEl = $(`<ul style="width: 300px"></ul>`);
                    this.popupMenuEl.on('click', 'a', (e) => {
                        Exceptions.handleExceptionLinkClick(e);
                    });
                }

                var rowId = $(e.currentTarget).attr('data-rowid');
                if (rowId == null)
                    return;

                var item = this.view.getItemById(rowId);
                if (!item)
                    return;

                var links = item.ExceptionLinks;
                if ((!links || !links.length) &&
                    (item.ExceptionSource != 'DataQualityTest'))
                    return;

                this.popupMenuEl.html('');

                if (item.ExceptionSource == 'DataQualityTest')
                    renderExceptionDialogLink(this.popupMenuEl, Data.TestResultDialog,
                        item.ExceptionContext, "View Test Result");

                links && Exceptions.renderExceptionLinks(this.popupMenuEl, links);

                popupMenuShow(this.popupMenuEl, e);
            });

            this.element.on('click.' + this.uniqueName, '.mute', (e) => {
                var rowId = $(e.currentTarget).attr('data-rowid');
                if (rowId == null)
                    return;

                var item = this.view.getItemById(rowId);
                if (!item)
                    return;

                const dialog = new ExceptionInboxIgnoringDialog();
                dialog.element.on('dialogclose panelclose', () => this.refresh());

                dialog.execute({
                    EntityId: item.RowId,
                    IgnoredUntil: item.IgnoredUntil
                });
            });
        }

        protected getDefaultSortBy() {
            return [ExceptionRow.Fields.RowId + " desc"];
        }

        protected getButtons() {
            return super.getButtons().filter(x => x.cssClass != "add-button");
        }

        protected getInitialTitle() {
            return "Exception Inbox";
        }

        protected getIncludeColumns(include) {
            super.getIncludeColumns(include);
            include[ExceptionRow.Fields.ExceptionLinks] = true;
            include[ExceptionRow.Fields.RowId] = true;
        }

        protected getColumns() {
            var columns = super.getColumns();

            var severity = Q.tryFirst(columns, x => x.field === ExceptionRow.Fields.SeverityCode);
            if (severity) {
                severity.format = ctx => {
                    var value = ctx.value?.toLowerCase();
                    var color;
                    switch (value) {
                        case "success":
                        case "pass":
                            color = "green";
                            break;
                        case "fail":
                        case "error":
                            color = "red";
                            break;
                        case "info":
                        case "information":
                            color = "blue";
                            break;
                        case "warn":
                        case "warning":
                            color = "orange";
                            break;
                        case "ignore":
                            color = "gray";
                            break;
                        default:
                            color = "black";
                    }

                    return `<span class="text-${color}"><i class="fa fa-dot-circle-o"></i> ${Q.htmlEncode(ctx.value)}</span>`;
                };
            }

            columns.splice(0, 0, {
                id: '__links',
                field: '__links',
                name: '',
                width: 30,
                maxWidth: 30,
                minWidth: 30,
                formatter: Serenity.SlickHelper.convertToFormatter(ctx => {

                    if (!ctx.item)
                        return "";

                    var links = ctx.item.ExceptionLinks || [];
                    if (!links.length &&
                        (ctx.item as ExceptionRow).ExceptionSource != "DataQualityTest")
                        return "";

                    return `<a class="inline-action exception-links" title="links" 
data-rowid="${ctx.item.RowId}"><i class="fa fa-bars"></i></a>`;
                }),
                headerFilterType: Serenity.HeaderFilterType.disabled,
                sortable: false
            });

            columns.splice(Q.indexOf(columns, col => col.field === ExceptionRow.Fields.IgnoredUntil), 0, {
                id: '__mute',
                field: null,
                name: '',
                width: 30,
                maxWidth: 30,
                minWidth: 30,
                formatter: Serenity.SlickHelper.convertToFormatter((ctx: { item: ExceptionRow }) => {
                    if (!ctx.item || ctx.item.CompletedBy || ctx.item.ReviewedBy)
                        return "";

                    if (!ctx.item.IgnoredUntil || isDateTimeInPast(ctx.item.IgnoredUntil))
                        return `<a class="inline-action mute" data-rowid="${ctx.item.RowId}" title="New Ignore"><i class="mdi mdi-volume-off text-purple" style="font-size: 19px"></i></a>`

                    return `<a class="inline-action mute" data-rowid="${ctx.item.RowId}" title="Edit Ignore\nIgnored Until: ${Q.formatDate(ctx.item.IgnoredUntil)}"><i class="mdi mdi-volume-off text-gray" style="font-size: 19px"></i></a>`
                }),
                headerFilterType: Serenity.HeaderFilterType.disabled,
                sortable: false
            });
            

            return columns;
        }
    }
}